import Grid from "components/primitives/Grid";
import Tables from "components/Tables";
import { tableCells as athleteTableCells } from "components/AthleteHub/AthleteTable/AthleteTable.config";
import AthleteTableIconButtonControls from "components/AthleteHub/AthleteTable/AthleteTableControls/AthleteTableIconButtonControls";
import { useMemo } from "react";

interface GroupAthleteTableControlsProps {}

function GroupAthleteTableControls(props: GroupAthleteTableControlsProps) {
  const tableControlsConfig = useMemo(() => ({ showDeleteAthleteAction: false }), []);
  return (
    <>
      <Grid {...Tables.controlsContainerProps}>
        <Grid {...athleteTableCells.name} pl={1} pr={1} minWidth={320} maxWidth={480} size={{ xs: 6, lg: 4 }}>
          <Tables.Components.SearchTextInput />
        </Grid>
        <AthleteTableIconButtonControls config={tableControlsConfig} />
      </Grid>
    </>
  );
}

export default GroupAthleteTableControls;
